/* LOCAL DRAFT: event-only reuse of the existing agency Google tag.
 * Contact deduplication is same-tab only; a native contact form has no receipt ID.
 * Never send a token, form value, form ID, raw URL, phone number or customer identifier.
 */
(function (window, document) {
  'use strict';

  if (window.location.hostname !== 'sydevelop.com' || window.__syJob6aEventsInstalled) return;
  window.__syJob6aEventsInstalled = true;

  var DESTINATION = 'G-4Z4NM150DS';
  var PENDING_KEY = 'sy:job6a:contact:pending:v1';
  var TTL_MS = 15 * 60 * 1000;
  var CONTAINER = '[data-sy-contact-container="agency_contact"]';
  var privacyFeatureRequested = false;
  var privacyFeaturePending = false;
  var privacyFeatureFailed = false;
  var contactResponseWait = null;
  var PRIVACY_READY_WAIT_MS = 2000;
  var contactResponseHandled = false;

  function privacyApiAvailable() {
    try {
      return typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function';
    } catch (_) {
      return false;
    }
  }

  function analyticsAllowed() {
    try {
      return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function requestPrivacyApi() {
    if (privacyFeatureRequested) return;
    try {
      if (privacyApiAvailable()) return;
      if (typeof window.Shopify.loadFeatures !== 'function') return;
      privacyFeatureRequested = true;
      privacyFeaturePending = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        privacyFeaturePending = false;
        privacyFeatureFailed = Boolean(error);
        // Only the first decision for an already accepted response may await API loading.
        // This never grants consent, queues phone actions or listens for consent grants.
        finishPrivacyWait(privacyFeatureFailed);
      });
    } catch (_) {
      privacyFeaturePending = false;
      privacyFeatureFailed = true;
      finishPrivacyWait(true);
    }
  }

  function transportAvailable() {
    return typeof window.gtag === 'function';
  }

  function emit(name, parameters) {
    if (!analyticsAllowed() || !transportAvailable()) return;
    try {
      parameters.send_to = DESTINATION;
      // Override automatic page context with an allowlisted public path and static title.
      // Never forward query/hash/referrer text, including the optional owner debug flag.
      var publicPaths = ['/', '/pages/contact', '/pages/online-consultation', '/pages/office-consultation'];
      parameters.page_location = 'https://sydevelop.com' +
        (publicPaths.indexOf(window.location.pathname) !== -1 ? window.location.pathname : '/');
      parameters.page_referrer = '';
      parameters.page_title = 'SY Develop';
      if (new URLSearchParams(window.location.search).get('sy_measurement_debug') === '1') {
        parameters.debug_mode = true;
      }
      window.gtag('event', name, parameters);
    } catch (_) {
      // The visitor action continues. An uncertain dispatch is never retried.
    }
  }

  function clearPending() {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
      return window.sessionStorage.getItem(PENDING_KEY) === null;
    } catch (_) {
      return false;
    }
  }

  function placement(anchor) {
    if (anchor.closest('footer')) return 'footer';
    if (anchor.closest('header')) return 'header';
    if (anchor.closest('#booking')) return 'booking_panel';
    if (anchor.closest('.sy-hero, .sy-connect-hero, .sy-growth-hero')) return 'hero';
    if (window.location.pathname === '/pages/contact') return 'contact';
    return 'other';
  }

  function onClick(event) {
    if (event.defaultPrevented) return;
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var anchor = target.closest('a[href]');
    if (!anchor) return;
    var agencyPhone = anchor.getAttribute('href') === 'tel:+19162226645';
    try {
      agencyPhone = agencyPhone || window.__sySearchWebsiteCallAnchors.has(anchor) === true;
    } catch (_) { /* No registered replacement: preserve the original exact target. */ }
    if (!agencyPhone) return;
    emit('phone_click', { contact_target: 'agency_main_phone', cta_placement: placement(anchor) });
  }

  function nativeContactForm(form) {
    if (!form || typeof form.matches !== 'function' || !form.matches('form.contact-form__form') ||
        !form.closest(CONTAINER) || !form.id || form.id.indexOf('ContactForm-') !== 0) return false;
    try {
      var action = new URL(form.getAttribute('action'), window.location.href);
      return (form.getAttribute('method') || '').toLowerCase() === 'post' &&
        action.origin === window.location.origin && action.pathname === '/contact';
    } catch (_) {
      return false;
    }
  }

  function onSubmit(event) {
    var form = event.target;
    if (!nativeContactForm(form)) return;
    // Remove an old attempt before deciding whether this new attempt is trackable.
    // Privacy cleanup may occur under denied consent; no tracking state is then saved.
    if (!clearPending() || event.defaultPrevented || !analyticsAllowed() || !transportAvailable()) return;
    try {
      if (!form.checkValidity() || typeof window.crypto.randomUUID !== 'function') return;
      var pending = {
        version: 1,
        token: window.crypto.randomUUID(),
        path: window.location.pathname,
        formId: form.id,
        createdAt: Date.now()
      };
      if (!analyticsAllowed()) return;
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
    } catch (_) {
      clearPending();
    }
  }

  function pendingMatches(raw, marker) {
    try {
      var pending = JSON.parse(raw);
      var age = Date.now() - pending.createdAt;
      return pending.version === 1 &&
        typeof pending.token === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(pending.token) &&
        pending.path === window.location.pathname &&
        pending.formId === marker.getAttribute('data-sy-form-id') &&
        Number.isFinite(pending.createdAt) && age >= 0 && age <= TTL_MS;
    } catch (_) {
      return false;
    }
  }

  function claimAcceptedResponse(marker, deny, expectedRaw) {
    var raw;
    try {
      raw = window.sessionStorage.getItem(PENDING_KEY);
    } catch (_) {
      return;
    }
    // Never let this older response acknowledge or consume a newer submission attempt.
    if (raw !== expectedRaw) return;
    var matched = raw !== null && pendingMatches(raw, marker);
    // Synchronous same-tab claim before any transport: failed consumption cannot emit.
    // Consume denied/unavailable successes too, so later consent cannot replay them.
    if (!clearPending() || !matched || deny) return;
    emit('generate_lead', { lead_type: 'contact_form', form_source: 'agency_native_contact' });
  }

  function finishPrivacyWait(deny) {
    if (!contactResponseWait) return;
    var waiting = contactResponseWait;
    contactResponseWait = null;
    try {
      window.clearTimeout(waiting.timer);
    } catch (_) {
      deny = true;
    }
    claimAcceptedResponse(waiting.marker, deny || Date.now() > waiting.deadline || !privacyApiAvailable(), waiting.expectedRaw);
  }

  function cancelPrivacyWait() {
    if (!contactResponseWait) return;
    try { window.clearTimeout(contactResponseWait.timer); } catch (_) { /* no replay */ }
    contactResponseWait = null;
  }

  function processContactStatus() {
    var markers = document.querySelectorAll(CONTAINER + ' [data-sy-contact-status]');
    if (!markers.length) {
      // A challenge/intermediate page may load without the API. Preserve the earlier
      // permitted token without creating state or emitting anything under unknown consent.
      if (privacyApiAvailable() && !analyticsAllowed()) clearPending();
      return;
    }
    if (contactResponseHandled) return;
    // Even a failed storage claim is a final decision for this server response.
    // Later API/storage recovery or consent grants must not replay it.
    contactResponseHandled = true;
    // An error or ambiguous response cannot prove one accepted contact attempt.
    if (markers.length !== 1 || markers[0].getAttribute('data-sy-contact-status') !== 'accepted') {
      clearPending();
      return;
    }
    var marker = markers[0];
    // A restored/reloaded success page is historical and cannot acknowledge a new attempt.
    try {
      var navigation = window.performance.getEntriesByType('navigation');
      if (navigation.length !== 1 || navigation[0].type !== 'navigate') {
        clearPending();
        return;
      }
    } catch (_) {
      clearPending();
      return;
    }
    var expectedRaw;
    try {
      expectedRaw = window.sessionStorage.getItem(PENDING_KEY);
    } catch (_) {
      return;
    }
    if (expectedRaw === null || !pendingMatches(expectedRaw, marker)) {
      clearPending();
      return;
    }
    if (privacyFeatureFailed) {
      claimAcceptedResponse(marker, true, expectedRaw);
    } else if (privacyApiAvailable()) {
      claimAcceptedResponse(marker, false, expectedRaw);
    } else if (privacyFeaturePending) {
      contactResponseWait = { marker: marker, expectedRaw: expectedRaw, timer: null, deadline: Date.now() + PRIVACY_READY_WAIT_MS };
      try {
        contactResponseWait.timer = window.setTimeout(function () {
          finishPrivacyWait(true);
        }, PRIVACY_READY_WAIT_MS);
      } catch (_) {
        cancelPrivacyWait();
        claimAcceptedResponse(marker, true, expectedRaw);
      }
    } else {
      claimAcceptedResponse(marker, true, expectedRaw);
    }
  }

  requestPrivacyApi();
  document.addEventListener('click', onClick);
  document.addEventListener('submit', onSubmit, true);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      contactResponseHandled = true;
      cancelPrivacyWait();
      clearPending();
      return;
    }
    processContactStatus();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processContactStatus, { once: true });
  } else {
    processContactStatus();
  }
})(window, document);
